import { render } from "./author-course-list.vue?vue&type=template&id=30522aa0&scoped=true"
import script from "./author-course-list.vue?vue&type=script&lang=ts"
export * from "./author-course-list.vue?vue&type=script&lang=ts"

import "./author-course-list.vue?vue&type=style&index=0&id=30522aa0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30522aa0"

export default script